import { Link } from 'react-router-dom';
import { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const statusColor = comic.status === '连载中' ? 'bg-accent-500' : 'bg-secondary-500';

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-100">
        <img
          src={comic.cover}
          alt={`${comic.title} - 韩国漫画在线免费阅读`}
          title={`${comic.title} - 免费韩国漫画`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 text-xs font-medium text-background-50 rounded-full ${statusColor}`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-1.5 py-0.5 text-xs font-semibold text-background-50 bg-foreground-950/70 rounded">
            {comic.rating}
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/80 to-transparent p-3 pt-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <p className="text-xs text-background-50 line-clamp-2 leading-relaxed">{comic.description}</p>
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
        <div className="flex items-center gap-3 mt-1.5">
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {comic.views > 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}
          </span>
          <span className="text-xs text-foreground-400">{comic.updatedAt}</span>
        </div>
      </div>
    </Link>
  );
}